import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { FormBuilder } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

import { DnChargeService,  NotificationService } from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-dn-charge-sc',
  templateUrl: './dn-charge-sc.component.html'
})
export class DnChargeScComponent implements OnInit {

  reportsWrappr: any = null;
  loading = false;
  processing = false;
  exporting = false;
  downloadUrl = '';
  emptyResult = true;

  source = null;
  country = null;
  operator = null;
  shortCode = null;
  spiderAccount = null;
  day = null;
  realtime = false;
  resultName = '';

  filterable = {
    day: null
  };
  active = 1;

  redRowCheckbox = true;
  greenRowCheckbox = true;
  otherRowCheckbox = true;

  constructor(private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private dnChargeSvc: DnChargeService,
    private notification: NotificationService,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
    // this.search();
    this.source = this.route.snapshot.paramMap.get('source');
    this.country = this.route.snapshot.paramMap.get('country');
    this.operator = this.route.snapshot.paramMap.get('operator');
    this.shortCode = this.route.snapshot.paramMap.get('shortCode');
    this.spiderAccount = this.route.snapshot.paramMap.get('spiderAccount');
    let day = this.route.snapshot.paramMap.get('day');
    this.realtime = this.route.snapshot.paramMap.get('realtime') == 'true';
    this.filterable.day = new Date(Number(day.substring(0, 4)), Number(day.substr(4, 2)) - 1, Number(day.substring(6)) + 1).toISOString().substring(0, 10);
    this.search();
  }

  back() {
    this.router.navigate(['/dashboard/dn-charge']);
  }

  close() {
    window.open('', '_self').close();
  }

  isDisplay(diffRate){
    if(diffRate >= 5){
      return this.redRowCheckbox;
    }else if(diffRate >= 1){
      return this.greenRowCheckbox;
    }else{
      return this.otherRowCheckbox;
    }
  }

  search() {
    this.redRowCheckbox = true;
    this.greenRowCheckbox = true;
    this.otherRowCheckbox = true;
    var day = formatDate(this.filterable.day, 'yyyyMMdd', 'en');
    this.loadPage(day);
  }
  export() {
    this.exporting = true;
    var day = formatDate(this.filterable.day, 'yyyyMMdd', 'en');
    let params = {
      day: day,
      source: this.source,
      country: this.country,
      operator: this.operator,
      shortCode: this.shortCode,
      spiderAccount: this.spiderAccount,
    }
    this.dnChargeSvc.export(params, this.realtime)
      .subscribe(res => {
        this.downloadUrl = res.data;
        document.getElementById('download').click();
        this.exporting = false;
      });
  }

  openModal(targetModal) {
    this.modalService.open(targetModal, {
      windowClass: 'modal-holder',
      size: 'lg'
    });
  }

  private loadPage(date) {
    this.emptyResult = true;
    this.loading = true;
    this.reportsWrappr = null;
    let params = {
      day: date,
      source: this.source,
      country: this.country,
      operator: this.operator,
      shortCode: this.shortCode,
      spiderAccount: this.spiderAccount,
    }
    this.resultName = this.realtime ? 'Realtime' : 'Offline';
    // get page of items from api
    this.dnChargeSvc.getAll(params, this.realtime).pipe(first()).subscribe(data => {
      if (data !== null) {
        this.loading = false;
        this.emptyResult = false;
        this.reportsWrappr = data.data;
      } else {
        this.loading = false;
        this.emptyResult = true;
        this.notification.showWarning("There is no report for this DN Charge.", "Empty Result");
      }
    });
  }

}
